import type { FC, ReactElement } from 'react';

import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useGameStateSlice } from '../../../store/slices/game/selectors';
import { ButtonVariant } from '../../controls/button/Button';

import {
  type BlockingModalActionButton,
  type BlockingModalContentProps,
  BlockingModalContent,
} from './BlockingModalContent';

export const TableClosedConnected: FC = (): ReactElement => {
  const redirectToLobby = useRedirectToLobbyCallbackConnected();

  const openTime = useGameStateSlice.table()?.openTime;

  const dateTime = openTime ? new Date(openTime) : null;

  let blockingModalProps: BlockingModalContentProps;
  if (dateTime) {
    blockingModalProps = {
      messageComponent: (
        <>
          <L10nText tk="LOBBY_OPEN_TIME" />
          <h2 style={{ margin: 'var(--core-spacing-tiny) 0' }}>
            {dateTime.toLocaleTimeString('en-gb', { hour: '2-digit', minute: '2-digit' })}
          </h2>
          {dateTime.toLocaleDateString('en-gb')}
        </>
      ),
      titleTk: 'TABLE_IS_CLOSED',
    };
  } else {
    blockingModalProps = { messageTk: 'TABLE_CLOSED_ALERT' };
  }

  const action: BlockingModalActionButton[] = [
    {
      tk: 'OK',
      type: ButtonVariant.ACCENT,
      click: () => redirectToLobby(),
    },
  ];

  return <BlockingModalContent {...blockingModalProps} actions={action} />;
};
